export default {
  create: {
    title: 'Add',
    subtitle: 'Games',
  },
  edit: {
    title: 'Edit',
    subtitle: 'Game',
    button: {
      add: 'New game',
    },
  },
  list: {
    title: 'Loop',
    subtitle: 'List',
    add: 'New game',
  },
  card: {
    title: 'Loop',
    actions: 'Actions',
  },
  table: {
    title: 'Active games',
    searchPlaceholder: 'Search...',
  },
  form: {
    name: {
      label: 'Name:',
      placeholder: 'E.g.: Loop Level 1',
      invalid: 'Name is required',
    },
    showAnswer: {
      label: 'Show answer',
    },
    colored: {
      label: 'Colored',
    },
    columns: {
      label: 'Columns:',
    },
    rows: {
      label: 'Rows:',
    },
    numObstacles: {
      label: 'Number of obstacles:',
      auto: 'Automatic',
      tooltipAuto: 'Ideal suggestion: {count} obstacles for this grid.',
      tooltipManual: 'Set the number of obstacles manually.',
      parityHint: 'For this grid size, use an {parity} number of obstacles.',
      parityOdd: 'odd',
      parityEven: 'even',
    },
    pathWeight: {
      label: 'Line thickness:',
      thin: 'Thin',
      normal: 'Normal',
      bold: 'Thick',
    },
    prioritizeQuality: {
      label: 'Visual quality',
      enabled: 'Enabled',
      tooltip:
        'Generates several options and picks the one with the best distribution on the grid. May take longer.',
    },
    fastGeneration: {
      label: 'Fast generation',
      enabled: 'Enabled',
      tooltipLarge:
        'Enabled automatically: Grids larger than 8×8 require this optimized algorithm to generate instantly and avoid freezes.',
      tooltip:
        'Uses an optimized algorithm to generate instantly. Has a more geometric pattern.',
    },
  },
  button: {
    generate: 'Generate game',
  },
  sidebar: {
    exportHint: 'You need to save before exporting.',
    defaultFileName: 'puzzle-loop',
  },
  alert: {
    firstLoopFound: 'First loop found!',
    perfectLoopFound: 'Perfect loop found!',
    bestOptionFound: 'Best option found!',
    generateFailed:
      'Could not generate a closed loop. Try changing the obstacles.',
    workerError: 'Worker error {index}: {message}',
    workerCritical: 'Critical worker failure.',
    gameSaved: 'Game saved successfully!',
    workerErrors: {
      invalidParity: 'Incorrect parity for the grid size.',
      noUniqueSolution:
        'Could not find a unique solution within the attempt limit.',
    },
  },
};
